import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { screenSmMax, spacer8, spacer16, spacer24 } from '@spotify-internal/encore-foundation';
import { FeaturedContentHeadline } from '../../ui';
import { ThreeUpSegment } from './ThreeUpSegment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ThreeUp = styled.div.withConfig({
  displayName: "ThreeUpFeaturedContentModule__ThreeUp",
  componentId: "ktihz1-0"
})(["display:flex;flex-direction:column;padding-bottom:", ";& h1{padding-top:", ";padding-bottom:", ";}@media (max-width:", "){padding-bottom:", ";[data-aspect-ratio='21x9']{order:1;}}"], spacer24, spacer16, spacer8, screenSmMax, spacer8);
var Bottom = styled.div.withConfig({
  displayName: "ThreeUpFeaturedContentModule__Bottom",
  componentId: "ktihz1-1"
})(["display:flex;flex-direction:row;justify-content:space-between;@media (max-width:", "){flex-direction:column;}"], screenSmMax);
var SegmentWrapper = styled.div.withConfig({
  displayName: "ThreeUpFeaturedContentModule__SegmentWrapper",
  componentId: "ktihz1-2"
})(["width:25%;@media (max-width:", "){width:100%;}"], screenSmMax);
export var ThreeUpModule = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$headline = _ref.headline,
      headline = _ref$headline === void 0 ? '' : _ref$headline,
      image = _ref.image,
      _ref$caption = _ref.caption,
      caption = _ref$caption === void 0 ? '' : _ref$caption,
      _ref$segments = _ref.segments,
      segments = _ref$segments === void 0 ? [] : _ref$segments;
  var fchProps = {
    headline: headline,
    image: image,
    useFeaturedContentHeadline: true,
    caption: caption
  };
  return /*#__PURE__*/_jsxs(ThreeUp, {
    ref: ref,
    children: [/*#__PURE__*/_jsx(FeaturedContentHeadline, _objectSpread({}, fchProps)), /*#__PURE__*/_jsx(Bottom, {
      children: segments.map(function (segment) {
        return /*#__PURE__*/_jsx(SegmentWrapper, {
          children: /*#__PURE__*/_jsx(ThreeUpSegment, {
            threeUpSegment: segment
          })
        }, segment.headline);
      })
    })]
  });
});